import { render, staticRenderFns } from "./ProductProfile.vue?vue&type=template&id=39e89b94"
import script from "./ProductProfile.vue?vue&type=script&lang=js"
export * from "./ProductProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports